/** @jsx jsx */

// Packages
import { jsx, css } from '@emotion/react';

// Local
import classnames from 'classnames';
import { IconCtaArrow } from '../../Icons/IconCtaArrow';
import fallbackImage from '../../../../../../sites/_shared/assets/SF-GREEN.png';

// CSS
import '../../Result/article.css';

export function BlogCard({ cardProps }) {
  const { result, layout, className, controller, hideTitle, hideContent, blogRec, index } = cardProps;

	const lazy = index > 3 ? "lazy" : null;

  const core = result?.mappings?.core
	const content = result?.attributes?.content;
  const type = result?.attributes?.type;
	let title = core?.name;

	//Truncate blog posts with long names/descriptions
	//Only applies to recs
	if(blogRec == true && title?.length > 60) {
		title = title?.substring(0, 63) + "...";
	}

  //result.mappings.core.sku <-- This will help give you what type of content is being returned, if needed.
  
	//Metafield blog featured image - can be used to save MB for performance
  const blogfeaturedimgmetafield = result?.attributes?.blogfeaturedimgmetafield;
	const domain = window.Resources.domain;
	const metafieldPrefix = `//${domain}/cdn/shop/`;

	//If blog metafield image exists, show that one.
	//If not, show the original blog image.
	//If not, show the fallback "No image".
  const imageUrl = blogfeaturedimgmetafield !== undefined ? blogfeaturedimgmetafield : core.imageUrl ? core.imageUrl : fallbackImage;

	//Format image url.
	//Previously, the metafield image url would return without "cdn/shop" prefix, but now it doesnt do that anymore? Leaving this logic here just in case anyways.
	const imageUrlPrepend = !imageUrl.includes("/cdn/shop/") ? metafieldPrefix + imageUrl : imageUrl;

	//Remove any "/files" duplicates from the string. Sometimes metafield returns with "/files/files" in the url and cause broken image links. No idea why.
	const imageUrlTrimmed = imageUrlPrepend.replace(/(files\/)(?=.*\1)/g, "");
	
  const imageClass = imageUrl == fallbackImage ? 'ss__result__image-fallback' : '';

	return (
		<article
			className={classnames(
				'ss__result ss__result-article',
				typeof hoverImage != 'undefined' && 'ss__result__hover',
				`ss__result--${layout}`,
				className
			)}
		>
			<a
				href={core.url}
				onClick={(event) => {
					controller?.track?.product?.click(event, result);
				}}
				className="ss__result-link"
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						<div className={classnames('ss__image', 'ss__result__image', `${imageClass}`)}>
							<img
								id={`ProductImage-${result.id}`}
								alt={core.name}
								class="product__img product__img--main lazyload"
								data-aspectratio="1.282258064516129"
								data-sizes="auto"
								data-image
								src={imageUrlTrimmed}
								loading={lazy}
							/>
						</div>
					</div>
					<div className="ss__result__details">
						{!hideTitle && (
							<div
								className="ss__result__details__content-title"
								dangerouslySetInnerHTML={{
									__html: title,
								}}
							/>
						)}

						{!hideContent && (
							<div
								className="ss__result__details__content"
								dangerouslySetInnerHTML={{
									__html: content,
								}}
							/>
						)}
						<div className="ss__result__details__content-link button button--link-1">
							{window.Resources.searchspring.productCards.articleCardReadMore}
							<IconCtaArrow />
						</div>
					</div>
				</div>
			</a>
		</article>
	);
}
